import React from 'react'
import { Navigate } from 'react-router-dom'
import { isStaff, readPid } from '@utils/accountSession.util'

/** Accounts for logged-in users (staff and tenant admins). */
const StaffGate = ({
  children,
}: {
  children: React.ReactNode
}): React.ReactElement => {
  if (!isStaff() && !readPid()) {
    return <Navigate to="/" replace />
  }
  return <>{children}</>
}

export default StaffGate
